module.exports = __webpack_public_path__ + "img/grow-one-for-good.3ba0a68a.png";